<template>
  <nav class="bg-ul-orange-400 sticky top-0 z-3 flex h-16 w-full items-center justify-between shadow-sm">
    <div class="ml-3 flex items-center gap-4">
      <router-link to="/">
        <p class="font-display h-10 text-4xl font-semibold text-black">UL26</p>
      </router-link>
      <PushNotificationButton />
    </div>
    <div class="hidden text-right text-black min-[1130px]:block">
      <router-link
        v-for="(navLocation, idx) in routes"
        :key="idx"
        :to="navLocation.path"
        class="nav-location min-w-16 cursor-pointer px-3 py-4 text-center font-medium select-none last:mr-2 hover:text-black/60"
        active-class="nav-location-active border-black border-b-2 border-solid"
        tag="div"
      >
        {{ navLocation.name }}
      </router-link>
    </div>
    <div @click="openSidebar" class="m-3 inline-block cursor-pointer hover:bg-white/25 min-[1130px]:hidden">
      <Icon icon="menu" class="h-10 text-black" />
    </div>
    <div
      sidebar-backdrop
      @click="closeSidebar"
      class="fixed inset-0 bg-black/50 min-[1130px]:hidden"
      :class="[isOpen ? '' : 'hidden']"
    />
    <div
      sidebar
      class="bg-ul-orange-150 ul-scroll fixed top-0 flex h-screen w-72 flex-col space-y-2 overflow-auto p-4 duration-200 min-[1130px]:hidden"
      :class="[isOpen ? 'shadow-sm' : '']"
      :style="`right: ${isOpen ? '0' : '-30rem'}; max-width: 80vw;`"
    >
      <router-link
        @click.native="closeSidebar"
        v-for="(navLocation, idx) in routes"
        :key="idx"
        :to="navLocation.path"
        class="nav-location cursor-pointer border-b-2 border-solid border-transparent px-3 py-3 text-center font-semibold text-black duration-300 select-none hover:text-black/60"
        active-class="nav-location-active text-black border-black"
        tag="div"
      >
        {{ navLocation.name }}
      </router-link>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { routes } from '../router'
import Icon from './Icon.vue'
import PushNotificationButton from './PushNotificationButton.vue'

const isOpen = ref(false)
const openSidebar = () => {
  isOpen.value = true
}
const closeSidebar = () => {
  isOpen.value = false
}
</script>

<style></style>
